const accessReport = {
    AUDIT_LOG_LIST: { name: 'Audit Log', path: '/audit-log-list' },
    AUDIT_LOG_DETAILS: { name: 'Audit Log Details', path: '/audit-log-details' },
    IN_OUT_LOG_LIST: { name: 'In Out Log', path: '/in-out-log-report' },
    IN_OUT_LOG_PREVIEW: { name: 'In Out Log Preview', path: '/in-out-log-preview' },
    USER_STATUS_LIST: { name: 'User Status', path: '/user-status-report' },
    USER_STATUS_PREVIEW: { name: 'User Status Preview', path: '/user-status-preview' },
    ADMIN_REPORT: { name: 'Admin Report', path: '/admin-report' },
    FINANCIAL_REPORT: { name: 'Financial Report', path: '/financial-report' },
    OCCUPANCY_REPORT: { name: 'Occupancy Report', path: '/occupancy-report' },
    TICKET_RESOLUTION_REPORT: { name: 'Ticket Resolution Report', path: '/ticket-resolution-report' },
    VISITOR_TRAFFIC_REPORT: { name: 'Visitor Traffic Report', path: '/visitor-traffic-report' },
    MONITORING_AND_LOGS: { name: 'Monitoring and Logs', path: '/monitoring-and-logs' },
    AUDIT_TRAIL: { name: 'Audit Trail', path: '/audit-trail' },
    PLATFORM_ANALYTICS: { name: 'Platform Analytics', path: '/platform-analytics' },
}

export default accessReport;